var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Table } from "./index";
import theme from "../theme";
import { Grid, ToggleButtonGroup, CircularProgress, Accordion, AccordionDetails, AccordionActions, AccordionSummary, Box, useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
var SubSection = function (props) {
    var _a;
    var _b = useState(props.filterText), filterText = _b[0], setFilterText = _b[1];
    var _c = useState(props.filterKey), filterKey = _c[0], setFilterKey = _c[1];
    var _d = useState(props.options), options = _d[0], setOptions = _d[1];
    var _e = useState(props.searchText), searchText = _e[0], setSerchText = _e[1];
    var _f = useState(), data = _f[0], setData = _f[1];
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var isTablet = useMediaQuery(theme.breakpoints.down("lg"));
    useEffect(function () {
        var _a;
        setFilterText(filterText);
        setData((_a = props.data) === null || _a === void 0 ? void 0 : _a.filter(function (req) { return req["".concat(filterKey)] == filterText; }));
    }, [props.filterText, props.data]);
    useEffect(function () {
        setSerchText(props.searchText);
    }, [props.searchText]);
    useEffect(function () {
        var o = __assign({}, options);
        o["searchText"] = searchText;
        o["pagination"] = false;
        setOptions(o);
    }, [searchText]);
    var handleFilter = function (e, value) {
        var _a;
        if (value) {
            setFilterText(value);
            setData((_a = props.data) === null || _a === void 0 ? void 0 : _a.filter(function (req) { return req["".concat(filterKey)] == value; }));
            if (props.onChange) {
                props.onChange(props.id, value);
            }
        }
        else {
            e.stopPropagation();
        }
    };
    return (_jsx(_Fragment, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Accordion, __assign({ expanded: props.expanded, onChange: function (e, isExpanded) {
                    e.stopPropagation();
                    if (props.handleExpandChange) {
                        props.handleExpandChange(e, isExpanded, filterText);
                    }
                }, sx: {
                    marginTop: '8px',
                    marginBottom: '8px',
                    '&:before': { height: '0px !important' },
                    '& .MuiCollapse-wrapper': { display: props.expanded ? 'flex' : 'none' }
                } }, { children: [_jsxs(AccordionSummary, __assign({ "aria-controls": "accordion", id: "accordion", expandIcon: _jsx(_Fragment, {}), sx: {
                            backgroundColor: "var(--palette-offwhite-3)",
                            padding: "0px 16px",
                            borderRadius: '10px',
                            margin: "10px",
                            color: "var(--palette-black-1)",
                            height: "auto",
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                                margin: '10px',
                                width: isMobile ? '100%' : 'unset',
                            }
                        }, disableRipple: true }, { children: [" ", _jsxs(Grid, __assign({ container: true, alignItems: 'center', sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                } }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }, { children: _jsx(Box, __assign({ sx: {
                                                display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', '& .MuiTypography-root': { fontWeight: 600 },
                                                flexDirection: isMobile ? 'column' : 'row'
                                            } }, { children: props.components.header && (_a = props.components).header.apply(_a, props) })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 12, md: 6, lg: 8, xl: 9 }, { children: _jsx(AccordionActions, __assign({ sx: { justifyContent: isMobile ? 'flex-start' : '' } }, { children: _jsx(ToggleButtonGroup, __assign({ size: "large", exclusive: true, onChange: handleFilter, value: filterText, sx: {
                                                    borderRadius: '10px', padding: '-20px', display: 'flex', flexWrap: 'wrap',
                                                    '& .MuiTypography-root': { fontSize: '14px', fontWeight: 600 },
                                                    '&:focus': { outline: 'none' }
                                                } }, { children: props.components.filters.map(function (f) { return f(); }) })) })) }))] }))] })), !data && _jsx(CircularProgress, {}), data && data.length > 0 && (_jsx(AccordionDetails, { children: _jsx(Table.Table, { searchKeys: props.searchKeys || [], title: props.title || "", columns: props.columns, data: data, options: options }) })), data && (data === null || data === void 0 ? void 0 : data.length) === 0 && (props.components.emptyPage || (_jsx("div", __assign({ style: {
                            color: 'black',
                            border: '1px solid #E2E2E2',
                            padding: '15px',
                            marginTop: '20px'
                        } }, { children: "There are no requirements." }))))] })) })) }));
};
export default SubSection;
